export const EMAIL = 'support@quadra-diffusion.fr';
export const PASSWORD = 'support';
export const PASSWORD_SUIVI = 'silverfox';